import type {
  AIActionKey,
  ModelPolicy,
  SubscriptionCatalog,
  SubscriptionSnapshot,
} from '../../../types/src/subscription';
import { subscriptionCatalog } from './catalog';

export function selectModelPolicy(
  snapshot: SubscriptionSnapshot,
  actionKey?: AIActionKey,
  options?: { complexity?: 'standard' | 'complex' },
  catalog: SubscriptionCatalog = subscriptionCatalog,
): ModelPolicy {
  if (!actionKey) {
    return snapshot.modelPolicy;
  }

  const action = catalog.aiActions[actionKey];
  if (!action || action.planSet === 'onboarding') {
    return 'sonnet_only';
  }

  if (action.premiumOnComplexOnly && options?.complexity !== 'complex') {
    return 'sonnet_only';
  }

  return snapshot.modelPolicy;
}
